import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  // change photo d'identité recto de l'utilisateur connecté
  // /api/upload/photo/idcardrecto
  uploadIdCardRecto(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post(`${environment.url}/upload/photo/idcardrecto`, formData, {'headers': headers});
  }

  // change photo d'identité verso de l'utilisateur connecté
  // api/upload/photo/idcardverso
  uploadIdCardVerso(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post(`${environment.url}/upload/photo/idcardverso`, formData, {'headers': headers});
  }

  // change photo d'identité selfie de l'utilisateur connecté
  // api/upload/photo/idcardselfie
  uploadIdCardSelfie(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post(`${environment.url}/upload/photo/idcardselfie`, formData, {'headers': headers});
  }

  // change photo de profil de l'utilisateur connecté
  // api/upload/photo/profil
  uploadIdCardProfil(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post(`${environment.url}/upload/photo/profil`, formData, {'headers': headers});
  }

  // Charger l'image de la catégorie
  // /api/upload/photo/category/{id}
  uploadCategoryImage(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post(`${environment.url}/upload/photo/category`, formData, {'headers': headers});
  }
}
